import * as React from 'react'
import { Route, Routes, useParams } from 'react-router-dom'
import { ErrorBoundary } from '@/modules/shared/components/ErrorBoundary'
import { ErrorFallback } from '@/modules/shared/components/ErrorFallback'
import { AppLayoutDahboardWithNav } from '@/modules/shared/layouts/AppLayoutDahboardWithNav'
import { toRelativeRoute, wrapRoutesWithRouter } from '@/modules/shared/utils/routerPaths'
import { PermissionGuard } from '@/modules/shared/components/NoPermission'
import { moduleAccess } from '@/modules/shared/permissions'

const wrappedUsersRoutes = wrapRoutesWithRouter(usersRoutes)
import { usersRoutes } from './routes'
import { usersPath } from './index'
import { UsersLayout } from './UsersLayout'

const UsersModuleImpl: React.FC = () => {
  const { companyId } = useParams<{ companyId: string }>()

  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
        <AppLayoutDahboardWithNav>
          <PermissionGuard companyId={companyId} {...moduleAccess.users}>
            <UsersLayout companyId={companyId!}>
              <ErrorBoundary fallback={(e) => <ErrorFallback error={e.error} onRetry={e.reset} />}>
                <Routes>
                  {wrappedUsersRoutes.map((route) => (
                          <Route
                        key={route.path}
                        path={`${toRelativeRoute(route.path, usersPath)}/*`}
                        element={<route.Component />}
                      />
                        ))}

                  {/* fallback */}
                  <Route
                    path="*"
                    element={<div>Users Module - Select a view</div>}
                  />
                </Routes>
              </ErrorBoundary>
            </UsersLayout>
          </PermissionGuard>
        </AppLayoutDahboardWithNav>
    </ErrorBoundary>
  )
}

export const UsersModule = UsersModuleImpl
